<template>
  <div>
    <b-table
        :id="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :striped=striped
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :small="small"
        :hover="hover"
        :dark="dark"
        :fixed="fixed"
        :foot-clone="footClone"
        :no-border-collapse="noBorderCollapse"
        :items="items"
        :fields="fields"
        :head-variant="headVariant"
        :table-variant="tableVariant"
        :per-page="perPageProxy"
        :current-page="paginate.currentPage"
        :responsive="responsive"
        show-empty
        @row-clicked="onRowClicked"
    >
      <template #empty="scope">
        <div class="text-center text-dark font-size-base py-4">{{ $t("general.no_records_found") }}</div>
      </template>

      <template #emptyfiltered="scope">
        <div class="text-center text-dark font-size-base py-4" >{{ $t("general.no_records_found_filter") }}</div>
      </template>

      <template #cell(image)="data">
        <img :src="data.item.image" style="width: 50px;" class="center"/>
      </template>

      <template #cell(actions)="row">
        <b-button size="sm" class="btn btn-warning mr-5" v-b-modal.edit><i class="fa fa-pencil-alt mr-3"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="btn btn-danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(user_group_list_actions)="row">
        <b-button size="sm" class="btn btn-danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(group_actions)="row">
        <b-button size="sm" class="btn btn-borderless mr-5" v-b-modal.send><i class="fas fa-paper-plane mr-3"></i>Gönderim</b-button>
        <router-link
            to="/internal-tests-list"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a :href="href" size="sm" class="btn btn-warning mr-5" @click="navigate"><i class="fa fa-pencil-alt mr-3"></i>{{ $t('general.edit') }}</a>
        </router-link>
        <b-button size="sm" class="btn btn-danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(customer_group_actions)="row">
        <router-link
            to="/customer-tests-list"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a :href="href" size="sm" class="btn btn-warning mr-5" @click="navigate"><i class="fa fa-pencil-alt mr-3"></i>{{ $t('general.edit') }}</a>
        </router-link>
        <b-button size="sm" class="btn btn-danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(user_group_actions)="row">
        <router-link
            to="/user-group-list"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a :href="href" size="sm" class="btn btn-warning mr-5" @click="navigate"><i class="fa fa-pencil-alt mr-3"></i>{{ $t('general.edit') }}</a>
        </router-link>
        <b-button size="sm" class="btn btn-danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(checkbox)="row">
        <b-form-checkbox
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #head(checkbox)="row">
        <span class="text-info">
          <b-form-checkbox
              class="check_all"
              id="check_all"
              value="accepted"
          >
      </b-form-checkbox>
        </span>
      </template>

      <template #cell(radio)="row">
        <b-form-radio name="radio" value="B"></b-form-radio>
      </template>

      <template #cell(email_confirm)="row">
        <b-form-checkbox
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(sms_confirm)="row">
        <b-form-checkbox
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(user_image)="row">
        <img src="media/users/300_21.jpg" width="30" alt="">
      </template>

      <template #cell(message_share_campaigns)="row">
        <router-link
            to="/confirm-message-share-campaign"
            v-slot="{ href, navigate, isActive, isExactActive }">

          <a :href="href" size="xs" class="btn btn-success mr-5" @click="navigate"><i class="fa fa-check mr-3"></i>ONAY</a>
        </router-link>
        <router-link
            to="/report-message-share-campaign"
            v-slot="{ href, navigate, isActive, isExactActive }">

          <a :href="href" size="xs" class="btn btn-warning mr-5" @click="navigate"><i class="fa fa-list-ol mr-3"></i>RAPOR</a>
        </router-link>
        <router-link
            to="/edit-message-share-campaign"
            v-slot="{ href, navigate, isActive, isExactActive }">

          <a :href="href" size="xs" class="btn btn-primary mr-5" @click="navigate"><i class="fa fa-pencil-alt mr-3"></i>{{ $t('general.edit') }}</a>
        </router-link>
      </template>

      <template #cell(image)="row">
        <b-form-checkbox
            size="lg"
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(checkbox_status)="row">
        <b-form-checkbox
            size="lg"
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(checkbox_live_status)="row">
        <b-form-checkbox
            size="lg"
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(confirm_required)="row">
        <b-form-checkbox
            size="lg"
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(is_promotion)="row">
        <b-form-checkbox
            size="lg"
            value="accepted"
            unchecked-value="not_accepted"
        >
        </b-form-checkbox>
      </template>

      <template #cell(transfer_request_action)="row">
        <router-link :to="{ path: '/confirm-transfer-requests' }">
          <b-button size="sm" variant="outline-success"><i class="fas fa-check"></i>{{ $t('nap_transfer.confirm') }}</b-button>
        </router-link>
      </template>

      <template #cell(campaign_actions)="row">
        <router-link
            to="/edit-campaign"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a :href="href" size="sm" class="btn btn-warning mr-5" @click="navigate"><i class="fa fa-pencil-alt mr-3"></i>{{ $t('general.edit') }}</a>
        </router-link>
        <b-button size="sm" class="btn btn-danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(wave_actions)="row">
        <router-link
            to="/offer-delivery"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a :href="href" size="sm" class="btn btn-primary mr-2 btn-sm" @click="navigate"><i class="icon flaticon2-paper-plane"></i> {{ $t('general.delivery') }}</a>
        </router-link>
        <b-button size="sm" variant="warning" v-b-modal.edit_wave><i class="fas fa-pencil-alt"></i> {{$t('general.edit')}}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(user_action)="row">
        <router-link :to="{ path: '/edit-user' }">
            <b-button size="sm" variant="outline-primary"><i class="fas fa-pencil-alt"></i>{{ $t('general.edit') }}</b-button>
          </router-link>
      </template>

      <template #cell(customer_type_actions)="row">
        <b-button v-b-modal.edit_customer_type size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(contact_actions)="row">
        <b-button v-b-modal.edit_contact size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(sector_actions)="row">
        <b-button v-b-modal.edit_sector size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(project_type_actions)="row">
        <b-button v-b-modal.edit_project_type size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(research_type_actions)="row">
        <b-button v-b-modal.edit_research_type size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(things_to_do_actions)="row">
        <b-button v-b-modal.edit_things_to_do size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(product_type_actions)="row">
        <b-button v-b-modal.edit_product_type size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(customer_actions)="row">
        <b-button v-b-modal.edit_customer size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(project_status_actions)="row">
        <b-button v-b-modal.edit_project_status size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(currency_actions)="row">
        <b-button v-b-modal.edit_currency size="sm" variant="warning"><i class="fas fa-pencil-alt mr-2"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" class="ml-2" variant="danger"><i class="fa fa-trash-alt mr-3"></i>{{ $t('general.delete') }}</b-button>
      </template>

      <template #cell(nap_transfer_action)="row">
        <router-link :to="{ path: '/edit-transfer-campaign' }">
          <b-button size="sm" variant="outline-primary"><i class="fas fa-pencil-alt"></i>{{ $t('general.edit') }}</b-button>
        </router-link>
      </template>

      <template #cell(delivery_report_action)="row">
        <b-button size="sm" v-b-modal.delivery_report variant="outline-primary"><i class="fas fa-search-plus"></i>{{$t('general.detail')}}</b-button>
      </template>

      <template #cell(code_pool_action)="row">
        <b-button v-b-modal.upload_code_list size="sm" variant="outline-warning" class=" mr-3"><i class="fa fa-upload mr-3"></i>Kod Listesi Yükle</b-button>
        <b-button v-b-modal.template size="sm" variant="outline-dark" class="mr-3"><i class="fas fa-fill-drip"></i>Şablon</b-button>
        <b-button v-b-modal.code_pool_edit size="sm" variant="outline-primary"><i class="fas fa-pencil-alt"></i>{{ $t('general.edit') }}</b-button>
        <b-button size="sm" variant="outline-danger" class=" ml-3"><i class="fa fa-trash-alt mr-3"></i>Sil</b-button>
      </template>

      <template #cell(status)="data">
        <span class="badge" :class="getStatusClass(data.item.status_id)">{{ data.item.status }}</span>
      </template>

      <template #cell(user_info)="row">
        <router-link
            to="/edit-user"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <a :href="href" size="sm" class="btn btn-outline-primary mr-5 btn-sm" @click="navigate"><i class="fa fa-user mr-3"></i>{{ row.item.user_info }}</a>
        </router-link>
      </template>

    </b-table>
    <Pagination v-if="paginate" :paginate="paginate" :page.sync="pageProxy" :perPage.sync="perPageProxy"></Pagination>
  </div>
</template>

<script>

import Pagination from "@/assets/components/dataTable/Pagination";
import Swal from "sweetalert2";

export default {
  name: "dataTable",
  props: {
    id: {
      default: "my-table",
      required: false
    },
    fields: {
      default: [],
      type: Array,
      required: true
    },
    items: {
      default: [],
      type: Array,
      required: true
    },
    title: {
      default: null,
      type: String
    },
    paginate: null,
    striped: {
      type: Boolean,
      default: true
    },
    sortBy: {
      type: String
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    footClone: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: 'none'
    },
    tableVariant: {
      type: String,
      default: 'light'
    },
    noBorderCollapse: {
      type: Boolean,
      default: false
    },
    page: {
      default: 1,
      required: false
    },
    perPage: {
      type: Number,
      default: 10,
      required: false,
    },
    responsive: {
      required: false,
      default: true,
    }
  },
  components: {Pagination},
  data() {
    return {}
  },

  computed: {
    perPageProxy: {
      set(value) {
        this.$emit('update:perPage', value)
      },
      get() {
        return this.perPage;
      },
    },
    pageProxy: {
      set(value) {
        this.$emit('update:page', value)
      },
      get() {
        return this.page;
      },
    },
  },

  methods: {
    ConfirmButton(){
      Swal.fire({
        title: "",
        text: "Kampanya başarıyla onaylandı!",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Tamam",
      });
    },
    getStatusClass(status) {
      let classes = ['badge-success', 'badge-primary', 'badge-warning', 'badge-info', 'badge-light', 'badge-dark','badge-danger']
      return classes[status]
    },
    onRowClicked(item, index, event){
      this.$emit('row-clicked', item, index, event);
    },

    getNoImage(item, index, event){
      this.$emit('row-clicked', item, index, event);
    }
  }
}
</script>

<style scoped>

</style>
